/* From snippets/trust-badges.liquid. Loaded only where that file renders; the guard stops a second copy running
   when the section is rendered twice or swapped in by the bundle switcher. */
(function () {
  if (window.__cancha_trust_badges_loaded) return;
  window.__cancha_trust_badges_loaded = true;

  (function () {
    function positionPopover(pop) {
      var trigger = document.querySelector('[popovertarget="' + pop.id + '"]');
      if (!trigger) return;
      var rect = trigger.getBoundingClientRect();
      pop.style.top = (rect.bottom + 8) + 'px';
      var width = pop.offsetWidth;
      var left = rect.left + rect.width / 2 - width / 2;
      left = Math.max(8, Math.min(left, window.innerWidth - width - 8));
      pop.style.left = left + 'px';
    }

    document.addEventListener('toggle', function (event) {
      var pop = event.target;
      if (!pop.classList || !pop.classList.contains('cancha-trust__pop')) return;
      if (event.newState === 'open') positionPopover(pop);
    }, true);
  })();
})();
